export default "__VITE_ASSET__CoooyOcO__"